import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { services } from "../mock";
import { SectionLabel, OrangeButton, Reveal } from "../components/common";

const ServiceCard = ({ s }) => {
  const Icon = Icons[s.icon] || Icons.HardHat;
  return (
    <div className="group relative h-[420px] overflow-hidden rounded-lg">
      <img
        src={s.img}
        alt={s.title}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B102D] via-[#0B102D]/40 to-transparent transition-colors duration-500 group-hover:from-[#CD0008] group-hover:via-[#CD0008]/70" />
      <span className="absolute top-6 left-6 w-14 h-14 flex items-center justify-center bg-[#CD0008] text-white rounded-md group-hover:bg-white group-hover:text-[#CD0008] transition-colors">
        <Icon size={26} />
      </span>
      <div className="absolute bottom-0 left-0 right-0 p-7">
        <h3 className="font-display font-bold text-white text-2xl mb-2">{s.title}</h3>
        <p className="text-white/0 group-hover:text-white/90 text-sm leading-relaxed max-h-0 group-hover:max-h-32 overflow-hidden transition-all duration-500">
          {s.desc}
        </p>
        <Link
          to="/services"
          className="inline-flex items-center gap-2 mt-4 text-white font-display font-semibold text-sm uppercase tracking-wide opacity-0 group-hover:opacity-100 transition-opacity"
        >
          Learn More <Icons.ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
};

const Services = () => {
  return (
    <section className="py-24 bg-[#F1F3F7]">
      <div className="max-w-[1320px] mx-auto px-5">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <SectionLabel>Our Services</SectionLabel>
            <h2 className="section-heading text-[#0B102D] text-4xl md:text-5xl">
              Building challenges &amp; smart solutions of construction
            </h2>
          </div>
          <OrangeButton to="/services">View Services</OrangeButton>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {services.slice(0, 6).map((s, i) => (
            <Reveal key={s.id} direction="up" delay={i * 120}>
              <ServiceCard s={s} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
